<template>
  <div>
    <div class="air__utils__heading">
      <h5>Exam Mark Entry</h5>
    </div>
    <div class="card" v-if="pagepermission.viewable">
      <div class="card-body">
        <div class="row mb-4">
          <div class="col-md-6 col-12 mb-3 mb-md-0">
            <label class="form-label">Select Exam</label>
            <a-select
              show-search
              placeholder="Select an exam"
              style="width: 100%"
              v-model="selectedExamName"
              :loading="loadingExams"
              @change="handleExamNameChange"
              option-filter-prop="children"
            >
              <a-select-option v-for="examName in uniqueExamNames" :key="examName" :value="examName">
                {{ examName }}
              </a-select-option>
            </a-select>
          </div>
          <div class="col-md-6 col-12">
            <label class="form-label">Select Class - Section - Subject</label>
            <a-select
              show-search
              placeholder="Select class, section and subject"
              style="width: 100%"
              v-model="selectedClassSectionSubject"
              :disabled="!selectedExamName"
              @change="handleExamChange"
              option-filter-prop="children"
            >
              <a-select-option v-for="exam in filteredClassSectionSubjects" :key="exam.class_section_exam_id + '-' + exam.subject_id" :value="exam.class_section_exam_id + '|' + exam.subject_id">
                {{ exam.class_name }} - {{ exam.section_name }} - {{ exam.subject_name }}
              </a-select-option>
            </a-select>
          </div>
        </div>

        <div v-if="selectedExamData">
          <mark-entry-table
            :students="students"
            :loading="loadingStudents"
            :exam-data="selectedExamData"
            :session-id="currentSessionId"
            :subject-config="subjectConfig"
            @refresh="handleExamChange"
          />
        </div>
        <div v-else-if="!loadingExams" class="text-center py-5">
          <a-empty description="Please select an exam to start entering marks" />
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MarkEntryTable from '@/components/exam/markentry'

export default {
  name: 'ExamMarkEntry',
  components: {
    MarkEntryTable,
  },
  beforeMount() {
    this.$roleutility.checkpermission('exam', 22).then(data => {
      this.pagepermission = data.pagePermission
    })
  },
  data() {
    return {
      loadingExams: false,
      loadingStudents: false,
      loadingSession: false,
      assignedExams: [],
      sessions: [],
      currentSessionId: undefined,
      selectedExamName: undefined,
      selectedClassSectionSubject: undefined,
      selectedExamData: null,
      students: [],
      subjectConfig: null,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
        approvable: false,
      },
    }
  },
  computed: {
    ...mapGetters(['user']),
    uniqueExamNames() {
      const names = this.assignedExams.map((e) => e.exam_name).filter(Boolean)
      return [...new Set(names)].sort()
    },
    filteredClassSectionSubjects() {
      if (!this.selectedExamName) return []
      return this.assignedExams.filter((e) => e.exam_name === this.selectedExamName)
    },
  },
  mounted() {
    this.getSessions()
    this.getAssignedExams()
  },
  methods: {
    getSessions() {
      this.loadingSession = true
      this.$http.get('/api/session').then(({ data }) => {
        this.sessions = data.data
        const current = this.sessions.find(s => s.is_current)
        if (current) {
          this.currentSessionId = current.id
        }
      }).finally(() => {
        this.loadingSession = false
      })
    },
    getAssignedExams() {
      if (!this.user || !this.user.id) return

      this.loadingExams = true
      this.$http
        .get('/api/staff/marks/assigned-exams', {
          params: {
            staff_id: this.user.id,
          },
        })
        .then(({ data }) => {
          this.assignedExams = data.data || []
        })
        .catch((error) => {
          this.$neoNotify.error(error)
        })
        .finally(() => {
          this.loadingExams = false
        })
    },
    handleExamNameChange() {
      this.selectedClassSectionSubject = undefined
      this.selectedExamData = null
      this.students = []
      this.subjectConfig = null
    },
    handleExamChange(val) {
      const examValue = val || this.selectedClassSectionSubject
      if (!examValue) {
        this.selectedExamData = null
        this.students = []
        this.subjectConfig = null
        return
      }

      const [classSectionExamId, subjectId] = examValue.split('|')
      const exam = this.assignedExams.find(
        (e) => e.class_section_exam_id === Number(classSectionExamId) && e.subject_id === Number(subjectId)
      )

      this.selectedExamData = exam
      this.fetchStudents(classSectionExamId, subjectId)
    },
    fetchStudents(classSectionExamId, subjectId) {
      this.loadingStudents = true
      this.$http
        .get('/api/staff/marks/exam-students', {
          params: {
            class_section_exam_id: classSectionExamId,
            subject_id: subjectId,
          },
        })
        .then(({ data }) => {
          this.students = data.data || []
          this.subjectConfig = data.subject_config || null
        })
        .catch((error) => {
          this.$neoNotify.error(error)
        })
        .finally(() => {
          this.loadingStudents = false
        })
    },
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
